<template>

    <div :class="[!is_enabled ? 'cursor-pointer hover:bg-gray-100' : '', 'group']" @click="clickRow">

        <div class="flex items-center font-bold flex-row justify-between px-4 py-5 sm:p-6">

            <div class="flex flex-grow items-center gap-3">
                <div class="w-12 h-12 rounded-2xl flex items-center justify-center" style="background-color:#1292EE;">
                    <img src="/img/helpscout_white.svg" class="h-7 w-7" />
                </div>
                <div class="flex flex-col items-start">
                    <span>Help Scout</span>
                </div>
            </div>
            <div class="flex text-white bg items-center" v-if="trigger">
                <div
                    class="inline-flex items-center px-0 py-2 bg-white border border-transparent rounded-md font-semibold text-xs text-birdie-green uppercase tracking-widest ">
                    Connected
                </div>
            </div>
            <transition name="fade">
                <div class="flex text-blue-500 items-center"
                    :class="{ 'opacity-50 pointer-events-none': !$page.props.canManageSettings }"
                    v-if="expandInfo && !is_enabled">
                    <button-link link="#" @click.prevent.stop="openInstall = !openInstall" class=""
                        :title="'Connect ' + app_name + ' with Helpscout'">
                        Connect
                    </button-link>
                </div>
            </transition>
        </div>


        <Flows :visible="expandInfo" :fixed="is_enabled" :flows="flows" :docs="docs" :name="name" />


        <!-- <div class="flex items-center font-bold flex-row">
            <div class="flex flex-grow items-center ">
                <img src="/img/helpscout-icon-800.png" class="h-9 w-9 mr-2 -ml-1" />
                Helpscout
            </div>
            <div class="flex text-blue-500 items-center" v-if="trigger">
                <vue-feather type="check" class="h-5 w-5 mr-1" ></vue-feather> connected
            </div>
        </div> -->


        <div v-if="trigger || openInstall" class="bg-gray-50 rounded-b-md px-4 py-5 sm:p-8 border-t border-gray-100">

            <div class="flex flex-col mt-4" v-if="!trigger">

                <div class="flex items-center flex-grow">

                    <div class="flex flex-col justify-center pr-4 w-full">
                        <h2 class="flex items-center text-lg text-gray-600">
                            <BookOpenIcon class="w-5 h-5 mr-2" /> Manual installation steps:
                        </h2>
                        <ul class="mt-4">
                            <li class="mb-3">
                                <strong>Step 1:</strong> Head to the <a href="https://secure.helpscout.net/apps/create"
                                    class="text-blue-500" target="_blank">Create an app page <vue-feather
                                        type="external-link" class="h-4 w-4 mx-2"></vue-feather></a> in Helpscout.
                            </li>
                            <li class="mb-3">
                                <strong>Step 2:</strong> Click Create App.
                            </li>
                            <li class="mb-3">
                                <strong>Step 3:</strong> Enter “Birdie” as the App Name.
                            </li>
                            <li class="mb-3">
                                <strong>Step 4:</strong> The Callback URL should be set to Birdie App URL:<br />
                                <div class="flex justify-between">
                                    <span
                                        class="cursor-pointer bg-gray-200 text-gray-500 hover:text-gray-600 px-3 py-1 rounded mt-1 flex items-center flex-shrink"
                                        v-clipboard:copy="helpscout_app_url" v-clipboard:success="confirmCopy"
                                        v-clipboard:error="errorCopy">{{ helpscout_app_url }}
                                        <ClipboardIcon class="h-3 w-3 ml-1"
                                            v-tippy="{ content: 'Click to copy in your clipboard' }" />
                                    </span>
                                    <div class="flex flex-grow"></div>
                                </div>
                            </li>
                            <li class="mb-3">
                                <strong>Step 5:</strong> Add this key to the Secret Key input box:<br />
                                <div class="flex justify-between">
                                    <span
                                        class="cursor-pointer bg-gray-200 text-gray-500 hover:text-gray-600 px-3 py-1 rounded mt-1 flex items-center flex-shrink"
                                        v-clipboard:copy="helpscout_app_secret" v-clipboard:success="confirmCopySecret"
                                        v-clipboard:error="errorCopySecret">{{ helpscout_app_secret }}
                                        <ClipboardIcon class="h-3 w-3 ml-1"
                                            v-tippy="{ content: 'Click to copy in your clipboard' }" />
                                    </span>
                                    <div class="flex flex-grow"></div>
                                </div>
                            </li>
                            <li>
                                <strong>Step 6:</strong> Choose the mailboxes where you’d like to use Birdie, then click
                                Save.
                            </li>
                        </ul>

                    </div>
                </div>


                <!--<div class="flex items-center flex-grow mb-5">
                Follow these instructions to install Zest for Helpscout:
                </div>
                <div class="flex items-center">-->
                <!-- <button-link
                        link="https://www.zendesk.com/apps/support/zest/"
                        class=""
                        title="Install Zest on Zendesk">
                        Install <vue-feather type="arrow-right" class="h-4 w-4 ml-2"></vue-feather>
                    </button-link> -->
                <!--<ul>
                        <li class="mb-3">
                            <strong>Step 1:</strong> Head to the <a href="https://secure.helpscout.net/apps/custom/" class="text-blue-500" target="_blank">Create Custom App page <vue-feather type="external-link" class="h-4 w-4 mx-2"></vue-feather></a> in Helpscout.
                        </li>
                        <li class="mb-3">
                            <strong>Step 2:</strong> Click Create Application.
                        </li>
                        <li class="mb-3">
                            <strong>Step 3:</strong> Enter Zest as the App Name, set Content Type to be Dynamic and add a word to the Secret Key input box.
                        </li>
                        <li class="mb-3">
                            <strong>Step 4:</strong> The Callback URL should be set to Zest' App URL
                            <span class="cursor-pointer bg-gray-100 text-gray-500 hover:text-gray-600 px-3 py-1 rounded"
                            v-clipboard:copy="helpscout_app_url"
                            v-clipboard:success="confirmCopy"
                            v-clipboard:error="errorCopy">{{ helpscout_app_url }} <vue-feather type="clipboard" class="h-3 w-3 ml-1" v-tippy="{content:'Click to copy in your clipboard'}"></vue-feather></span>
                        </li>
                        <li>
                            <strong>Step 5:</strong> Enable the Mailboxes you want Zest in and Save.
                        </li>
                    </ul>
                </div>-->
            </div>

            <div class="flex flex-col mt-3" v-if="trigger && !is_modal">
                <div class="flex items-center flex-grow">
                    <div class="flex justify-between items-center gap-x-2">
                        <span class="flex flex-shrink items-center gap-x-2">
                            <!-- <img src="/img/screen-recording.svg" alt="Screen Recording" class="w-4 h-4" /> -->
                            Your Helpscout app is connected with Secret Key:
                        </span>
                        <div class="flex justify-between text-sm">
                            <span
                                class="cursor-pointer bg-gray-200 text-gray-500 hover:text-gray-600 px-3 py-1 rounded mt-1 flex items-center flex-shrink"
                                v-clipboard:copy="helpscout_app_secret" v-clipboard:success="confirmCopySecret"
                                v-clipboard:error="errorCopySecret">{{ helpscout_app_secret }}
                                <ClipboardIcon class="h-3 w-3 ml-1"
                                    v-tippy="{ content: 'Click to copy in your clipboard' }" />
                            </span>
                            <div class="flex flex-grow"></div>
                        </div>
                    </div>
                </div>
                <!-- <div class="flex items-center flex-grow mt-3">
                    <list-toggle>
                        <template #title>
                        <span class="text-sm text-gray-600">Uninstall</span>
                        </template>
<template #content>
                            <ul>
                                <li class="mb-3">
                                    <strong>Step 1:</strong> Head to the <a href="https://secure.helpscout.net/apps/" class="text-blue-500" target="_blank">Apps page <vue-feather type="external-link" class="h-4 w-4 mx-2"></vue-feather></a> in Helpscout.
                                </li>
                                <li class="mb-3">
                                    <strong>Step 2:</strong> Click on the Zest Custom App you built.
                                </li>
                                <li class="mb-3">
                                    <strong>Step 3:</strong> Click the <em>Uninstall App</em> button.
                                </li>
                                <li class="mb-3">
                                    <strong>Step 4:</strong> Finally, remove it from your Zest account <a href="#"
                                    title="Uninstall Helpscout" target="_blank"
                                    @click.prevent="deleteIntegration"
                                    class="text-blue-500 mx-1 hover:text-blue-600 hover:underline">by clicking here</a>
                                </li>
                            </ul>
                        </template>
</list-toggle>
</div> -->
            </div>

            <!-- <div class="flex flex-row mt-3" v-if="trigger && !is_modal">
                <div class="flex items-center flex-grow">
                <span class="text-sm text-gray-600">
                        Please visit <a href="https://www.zendesk.com/apps/support/zest/" title="Zendesk Zest app" target="_blank"
                            class="text-blue-500 mx-1 hover:text-blue-600 hover:underline">
                                Zendesk App Store</a> to install Zest, or take a look at <a href="#" target="_blank" title="Helpscout integration help"
                                class="text-blue-500 mx-1 hover:text-blue-600 hover:underline">this guide</a> if you need help.
                    </span>
                </div>
            </div> -->

            <jet-section-border v-if="trigger && !is_modal && false" />

            <div class="flex flex-row" v-if="trigger && !is_modal && false">
                <div class="flex items-center flex-grow gap-x-2">
                    <!-- <img src="/img/screen-recording.svg" alt="Screen Recording" class="w-4 h-4" /> -->
                    <span class="">Helpscout agents can: </span>
                    <jet-dropdown align="left" width="80" class="flex self-center flex-grow" ref="triggerDropdown">
                        <template #trigger>
                            <span class="inline-flex rounded-md">
                                <button type="button"
                                    class="inline-flex items-center px-2 py-2 border border-transparent leading-4 font-medium rounded-md bg-transparent hover:bg-white  focus:outline-none focus:bg-gray-50 active:bg-gray-50 transition"
                                    :disabled="saving"
                                    :class="!saving ? 'text-blue-500 hover:text-blue-700' : 'text-gray-300 hover:text-gray-500'">
                                    <span class="font-bold" v-if="agents_can == 'send'">
                                        only send recordings
                                    </span>
                                    <span class="font-bold" v-else-if="agents_can == 'request'">
                                        only request recordings
                                    </span>
                                    <span class="font-bold" v-else>
                                        send and request recordings
                                    </span>
                                    <svg class="ml-2 -mr-0.5 h-4 w-4" xmlns="http://www.w3.org/2000/svg"
                                        viewBox="0 0 20 20" fill="currentColor">
                                        <path fill-rule="evenodd"
                                            d="M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z"
                                            clip-rule="evenodd" />
                                    </svg>
                                </button>
                            </span>
                        </template>
                        <template #content>
                            <inertia-link href="#"
                                class="block px-4 py-2 leading-5 text-gray-700 hover:bg-gray-100 focus:outline-none focus:bg-gray-100 transition rounded flex flex-row cursor-pointer"
                                :class="{ 'text-blue-500 font-bold': agents_can == 'all' }"
                                @click.prevent.stop="switchAgent('all')">
                                <span class="flex flex-grow">Send and request recordings</span>
                                <vue-feather v-if="agents_can == 'all'" type="check"
                                    class="w-4 h-4 ml-2 self-center"></vue-feather>
                            </inertia-link>
                            <inertia-link href="#"
                                class="block px-4 py-2 leading-5 text-gray-700 hover:bg-gray-100 focus:outline-none focus:bg-gray-100 transition rounded flex flex-row cursor-pointer"
                                :class="{ 'text-blue-500 font-bold': agents_can == 'send' }"
                                @click.prevent.stop="switchAgent('send')">
                                <span class="flex flex-grow">Only send recordings</span>
                                <vue-feather v-if="agents_can == 'send'" type="check"
                                    class="w-4 h-4 ml-2 self-center"></vue-feather>
                            </inertia-link>
                            <inertia-link href="#"
                                class="block px-4 py-2 leading-5 text-gray-700 hover:bg-gray-100 focus:outline-none focus:bg-gray-100 transition rounded flex flex-row cursor-pointer"
                                :class="{ 'text-blue-500 font-bold': agents_can == 'request' }"
                                @click.prevent.stop="switchAgent('request')">
                                <span class="flex flex-grow">Only request recordings</span>
                                <vue-feather v-if="agents_can == 'request'" type="check"
                                    class="w-4 h-4 ml-2 self-center"></vue-feather>
                            </inertia-link>
                        </template>
                    </jet-dropdown>
                </div>
            </div>


            <jet-section-border />


            <div class="flex flex-col" v-if="trigger && !is_modal">
                <div class="flex items-center flex-grow">
                    <div class="flex flex-col justify-between items-start gap-x-2">
                        <span class="flex flex-shrink items-center gap-x-2">
                            <!-- <img src="/img/screen-recording.svg" alt="Screen Recording" class="w-4 h-4" /> -->
                            Your Birdie link to paste in Auto Reply
                            <docs-link
                                href="https://docs.birdie.so/birdie-docs/helpdesk/helpscout/screen-recording/auto-reply" />
                        </span>

                        <div class="flex justify-between text-sm">
                            <span
                                class="cursor-pointer bg-gray-200 text-gray-500 hover:text-gray-600 px-3 py-1 rounded mt-1 flex items-center flex-shrink"
                                v-clipboard:copy="helpscout_autoreply" v-clipboard:success="copied">{{
                                helpscout_autoreply }}
                                <ClipboardIcon class="h-3 w-3 ml-1" v-tippy="{ content: 'copy in your clipboard' }" />
                            </span>
                            <div class="flex flex-grow"></div>
                        </div>
                    </div>
                </div>
            </div>

            <jet-section-border />


            <div class="flex flex-col" v-if="trigger && !is_modal">
                <div class="flex items-center flex-grow">
                    <div class="flex flex-col justify-between items-start gap-x-2">
                        <span class="flex flex-shrink items-center gap-x-2">
                            <!-- <img src="/img/screen-recording.svg" alt="Screen Recording" class="w-4 h-4" /> -->
                            Your Birdie link to paste in Saved Replies and/or Agent Signature
                            <docs-link
                                href="https://docs.birdie.so/birdie-docs/helpdesk/helpscout/screen-recording/saved-replies" />
                        </span>

                        <div class="flex justify-between text-sm">
                            <span
                                class="cursor-pointer bg-gray-200 text-gray-500 hover:text-gray-600 px-3 py-1 rounded mt-1 flex items-center flex-shrink"
                                v-clipboard:copy="helpscout_signature" v-clipboard:success="copied">{{
                                helpscout_signature }}
                                <ClipboardIcon class="h-3 w-3 ml-1" v-tippy="{ content: 'copy in your clipboard' }" />
                            </span>
                            <div class="flex flex-grow"></div>
                        </div>
                    </div>
                </div>
            </div>


            <jet-section-border v-if="trigger && !is_modal && trigger.enabled == 1" />


            <div class="flex flex-row" v-if="trigger && !is_modal && trigger.enabled == 1">

                <div class="flex items-start flex-grow gap-x-2">
                    <!-- <img src="/img/screen-recording.svg" alt="Screen Recording" class="w-4 h-4 mt-1" /> -->
                    <span class="">Birdie SDK & Birdie Link: Forward incoming recordings to your Helpscout
                        mailbox<br />
                        <span class="text-xs text-gray-500">Most setups don't need this - use with care as it could
                            result in new tickets being created while you've already received the recordings another
                            way. </span></span>

                </div>
                <div class="flex items-center flex-grow min-w-1/4 justify-end "
                    :class="{ 'pointer-events-none': !$page.props.canManageSettings }">

                    <jet-dropdown align="left" width="36" class="flex self-center" ref="helpscoutDropdown">
                        <template #trigger>
                            <span class="inline-flex rounded-md">
                                <button type="button"
                                    class="inline-flex items-center px-2 py-2 border border-transparent leading-4 font-medium rounded-md bg-transparent hover:bg-white  focus:outline-none focus:bg-gray-50 active:bg-gray-50 transition"
                                    :class="{ 'text-blue-500 hover:text-blue-700': trigger.enabled == 1, 'text-gray-300 hover:text-gray-500': trigger.enabled == 0 }">

                                    <span v-if="trigger.enabled == 1 && mailbox_default_name" class="font-bold">
                                        {{ mailbox_default_name }}
                                    </span>
                                    <span v-else class="font-bold">
                                        No forwarding
                                    </span>

                                    <svg class="ml-2 -mr-0.5 h-4 w-4" xmlns="http://www.w3.org/2000/svg"
                                        viewBox="0 0 20 20" fill="currentColor">
                                        <path fill-rule="evenodd"
                                            d="M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z"
                                            clip-rule="evenodd" />

                                    </svg>
                                </button>
                            </span>
                        </template>

                        <template #content>
                            <inertia-link href="#"
                                class="block px-4 py-2 leading-5 text-gray-700 hover:bg-gray-100 focus:outline-none focus:bg-gray-100 transition rounded flex flex-row"
                                :class="{ 'text-blue-500 font-bold': trigger.enabled == 0 }"
                                @click.prevent.stop="updateMailboxDefault(0)">
                                <span class="flex flex-grow">No forwarding</span>
                                <vue-feather v-if="trigger.enabled == 0" type="check"
                                    class="w-4 h-4 ml-2 self-center"></vue-feather>
                            </inertia-link>
                            <inertia-link v-for="mailbox in mailboxes" :key="mailbox.id" href="#"
                                class="block px-4 py-2 leading-5 text-gray-700 hover:bg-gray-100 focus:outline-none focus:bg-gray-100 transition rounded flex flex-row"
                                :class="{ 'text-blue-500 font-bold': mailbox.id == mailbox_default_id }"
                                @click.prevent.stop="updateMailboxDefault(mailbox)">
                                <span class="flex flex-grow">{{ mailbox.name }}</span>
                                <vue-feather v-if="mailbox.id == mailbox_default_id" type="check"
                                    class="w-4 h-4 ml-2 self-center"></vue-feather>
                            </inertia-link>
                        </template>
                    </jet-dropdown>

                    <!-- <toggle
                        :checked="enabled"
                        @click.prevent.stop
                        @update="toggleHelpscout"></toggle> -->
                </div>
            </div>



            <jet-section-border v-if="trigger && !is_modal" />

            <div class="flex flex-col" v-if="trigger && !is_modal">
                <div class="flex items-center flex-grow">
                    <list-toggle>
                        <template #title>
                            <span class="text-gray-500 flex items-center gap-x-2">
                                <!-- <img src="/img/screen-recording.svg" alt="Screen Recording"
                                    class="w-4 h-4 opacity-60" /> -->
                                Uninstall
                            </span>
                        </template>
                        <template #content>
                            <ul class="text-sm">
                                <li class="mb-3">
                                    <strong>Step 1:</strong> Head to the <a href="https://secure.helpscout.net/apps/"
                                        class="text-blue-500" target="_blank">Apps page <vue-feather
                                            type="external-link" class="h-4 w-4 mx-2"></vue-feather></a> in Helpscout.
                                </li>
                                <li class="mb-3">
                                    <strong>Step 2:</strong> Click on the Birdie App you built.
                                </li>
                                <li class="mb-3">
                                    <strong>Step 3:</strong> Click the <em>Uninstall App</em> button.
                                </li>
                                <li class="mb-3" :class="{ 'pointer-events-none': !$page.props.canManageSettings }">
                                    <strong>Step 4:</strong> Finally, remove it from your Birdie account <a href="#"
                                        title="Uninstall Helpscout" target="_blank" @click.prevent="deleteIntegration"
                                        class="text-blue-500 mx-1 hover:text-blue-600 hover:underline">by clicking
                                        here</a>
                                </li>
                            </ul>
                        </template>
                    </list-toggle>
                </div>
            </div>

            <jet-dialog-modal ref="modal" :show="show_delete_modal" maxWidth="lg" @close="show_delete_modal = false">
                <template v-slot:title>
                    <div class="text-gray-700">Uninstall Helpscout </div>
                </template>
                <template v-slot:content>
                    <div class="text-gray-600">Make sure you also uninstalled your Custom App into your Helpscout
                        account. <strong>Do you confirm uninstall?</strong></div>
                </template>
                <template v-slot:footer>
                    <div class="flex w-full flex-row justify-between">
                        <div class="flex">
                            <jet-secondary-button @click.prevent="show_delete_modal = false">
                                Cancel
                            </jet-secondary-button>
                        </div>
                        <div class="flex">
                            <jet-danger-button @click.prevent="deleteIntegrationConfirmed">
                                Uninstall
                            </jet-danger-button>
                        </div>
                    </div>
                </template>
            </jet-dialog-modal>

        </div>

    </div>

</template>

<script>
import Toggle from '@/Components/UI/Toggle'
import ButtonLink from '@/Jetstream/ButtonLink'
import ListToggle from '@/Components/UI/ListToggle'
import JetDropdown from '@/Jetstream/Dropdown'
import JetDropdownLink from '@/Jetstream/DropdownLink'
import JetDialogModal from '@/Jetstream/DialogModal'
import JetDangerButton from '@/Jetstream/DangerButton'
import JetSecondaryButton from '@/Jetstream/SecondaryButton'
import { BookOpenIcon } from "@heroicons/vue/24/outline"
import { ClipboardIcon } from "@heroicons/vue/16/solid"
import JetSectionBorder from '@/Jetstream/SectionBorder'
import Flows from '@/Components/Settings/Integrations/Flows'

export default {

    props: ['the_trigger', "is_modal", "helpscout_autoreply", "flows", "docs", "name"],

    components: {
        Toggle, ButtonLink, ListToggle, JetSecondaryButton,
        JetDropdown, JetDropdownLink, JetDialogModal,
        JetDangerButton, ClipboardIcon, JetSectionBorder,
        BookOpenIcon, Flows
    },

    created: function () {
        if (this.the_trigger) {
            this.trigger = this.the_trigger
            this.engine = JSON.parse(this.the_trigger.details)
            let metadata = JSON.parse(this.the_trigger.metadata)
            if (metadata.mailboxes) {
                this.mailboxes = metadata.mailboxes
            }
            if (metadata.mailbox_default) {
                this.mailbox_default_id = metadata.mailbox_default
                for (const m of this.mailboxes) {
                    if (m.id == this.mailbox_default_id) {
                        this.mailbox_default_name = m.name
                        break
                    }
                }
            }
            if (metadata.agents_can) {
                this.agents_can = metadata.agents_can
            }
        }

        //console.log(this.trigger)
    },

    data() {
        return {
            trigger: null,
            engine: {},
            mailboxes: [],
            mailbox_default_id: 0,
            mailbox_default_name: '',
            helpscout_app_url: this.$page.props.app_url + "/helpscout",
            helpscout_app_secret: this.$page.props.md5_teamslug,
            show_delete_modal: false,
            agents_can: 'all',
            app_name: this.$page.props.app_name,
            openInstall: false,
            saving: false,
            helpscout_signature: `Want to add a video of the issue? Click here to record your screen: https://${this.$page.props.user.current_team.slugname}.birdie.so/urec/helpscout`,
            is_enabled: this.the_trigger != false,
            expandInfo: false
        }
    },

    mounted: function () {
        //console.log(this.engine);
    },

    methods: {
        clickRow: function () {
            if (this.is_enabled) {
                return
            }
            this.expandInfo = !this.expandInfo
        },
        switchAgent: function (can) {
            this.agents_can = can
            this.updateTrigger()
        },
        // toggleHelpscout: function(checked) {
        //     this.trigger.enabled = checked ? 1 : 0
        //     this.updateTrigger()
        // },
        // toggle: function() {
        //     if (this.trigger.enabled == 1) {
        // 	    this.trigger.enabled = 0;
        //     } else {
        // 	    this.trigger.enabled = 1;
        //     }
        //     this.updateTrigger();
        // },
        updateMailboxDefault: function (mailbox) {
            if (mailbox == 0) {
                this.trigger.enabled = 0
                this.mailbox_default_id = 0
                this.mailbox_default_name = ''
            } else {
                this.trigger.enabled = 1
                this.mailbox_default_id = mailbox.id
                this.mailbox_default_name = mailbox.name
            }
            this.updateTrigger()
            // let url = this.$page.props.api_url+'/v1/integration/'+this.trigger.id;
            // var params = {
            //     enabled: this.trigger.enabled,
            //     helpscout_mailbox: this.mailbox_default_id
            // };
            // this.$refs.helpscoutDropdown.close()
            // axios.post(url, params)
            // .then(response => {
            //     //console.log(response.data);
            //     let options = {
            //         type: "default",
            //         timeout: 2500,
            //         position: "top-right",
            //         hideProgressBar: false,
            //     }
            //     this.$moshaToast("Setting updated", options)
            // })
            // .catch(e => {
            // 	console.error(e);
            // });
        },
        updateTrigger: function () {
            if (!this.$page.props.canManageSettings) {
                return
            }
            let url = this.$page.props.api_url + '/v1/integration/' + this.trigger.id;
            var params = {
                enabled: this.trigger.enabled,
                helpscout_mailbox: this.mailbox_default_id,
                agents_can: this.agents_can
            };
            if (this.$refs.helpscoutDropdown) {
                this.$refs.helpscoutDropdown.close()
            }
            if (this.$refs.triggerDropdown) {
                this.$refs.triggerDropdown.close()
            }
            axios.post(url, params)
            this.saving = true
                .then(response => {
                    //console.log(response.data);
                    let options = {
                        type: "default",
                        timeout: 2500,
                        position: "top-right",
                        hideProgressBar: false,
                    }
                    this.$moshaToast("Setting updated", options)
                    this.saving = false
                })
                .catch(e => {
                    console.error(e)
                    this.saving = false
                });
        },
        confirmCopy: function () {
            let options = {
                type: "default",
                timeout: 6000,
                position: "top-right",
                hideProgressBar: false,
            }
            this.$moshaToast("Link copied in your clipboard!", options)
        },
        errorCopy: function () {
            let options = {
                type: "danger",
                timeout: -1,
                position: "top-right",
            }
            this.$moshaToast("A browser error occured, link not copied", options)
        },
        confirmCopySecret: function () {
            let options = {
                type: "default",
                timeout: 6000,
                position: "top-right",
                hideProgressBar: false,
            }
            this.$moshaToast("Secret Key copied in your clipboard!", options)
        },
        errorCopySecret: function () {
            let options = {
                type: "danger",
                timeout: -1,
                position: "top-right",
            }
            this.$moshaToast("A browser error occured, key not copied", options)
        },
        deleteIntegration: function () {
            this.show_delete_modal = true
        },
        deleteIntegrationConfirmed: function () {
            if (!this.$page.props.canManageSettings) {
                return
            }
            this.show_delete_modal = false
            let url = this.$page.props.api_url + '/v1/integration-delete/' + this.trigger.id;
            var params = {};
            axios.post(url, params)
                .then(response => {
                    let options = {
                        type: "default",
                        timeout: 2500,
                        position: "top-right",
                        hideProgressBar: false,
                    }
                    this.$moshaToast("Helpscout uninstalled", options)
                    this.trigger = null
                    this.engine = {}
                })
                .catch(e => {
                    console.error(e);
                });
        }
    },

    computed: {
        enabled: {
            get: function () {
                return this.trigger.enabled == 1
            },
            set: function (newValue) {
                // do nothing
            }
        },
    }
}

</script>

<style scoped>
a.btn-zapier {
    display: inline-block;
    text-decoration: none;
    color: #E65528;
    text-indent: -9999px;
    font-size: 0.1rem;
    padding: 0.375rem 0.75rem;
    line-height: 1.5;
    border-radius: 0.25rem;
    background: #E65528 url(/img/zapier-full.svg) no-repeat center center;
    width: 139px;
    height: 40px;
    border-radius: 6.5px;
    background-size: 50%;
}
</style>
